import { Close } from '@mui/icons-material'
import { Box, IconButton, Stack, Typography } from '@mui/material'
import isNil from 'lodash/isNil'
import { ReactNode, useEffect, useRef } from 'react'
import { triggerConfettiFromElement } from '../../../utils/confetti'

type CelebrationBannerProps = {
  title: string
  subtitle?: string
  icon?: ReactNode
  onClose?: () => void
}

export const CelebrationBanner = ({ title, subtitle, icon, onClose }: CelebrationBannerProps) => {
  const emojiRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (isNil(emojiRef.current)) return
    triggerConfettiFromElement(emojiRef.current)
  }, [])

  const defaultIcon = (
    <span role="img" aria-label="celebration" style={{ fontSize: '40px' }}>
      🎉
    </span>
  )

  return (
    <Box
      sx={{
        position: 'relative',
        backgroundColor: 'neutralDark.300',
        borderRadius: '8px',
        overflow: 'hidden',
        mb: 1,
      }}
    >
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        sx={{
          px: 3,
          py: 2.5,
        }}
      >
        <Stack direction="row" alignItems="center" spacing={1.5} flex={1}>
          <Box
            ref={emojiRef}
            sx={{ flexShrink: 0, width: 52, height: 52, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
          >
            {icon ?? defaultIcon}
          </Box>
          <Stack spacing={0.25}>
            <Typography variant="HeaderSubtitleLargeSemibold" sx={{ color: 'white' }}>
              {title}
            </Typography>
            {!isNil(subtitle) && subtitle.length > 0 && (
              <Typography variant="HeaderSubtitleSmallMedium" sx={{ color: 'white', opacity: 0.8 }}>
                {subtitle}
              </Typography>
            )}
          </Stack>
        </Stack>
        {onClose && (
          <IconButton
            size="small"
            onClick={onClose}
            sx={{
              color: 'white',
              opacity: 0.8,
              '&:hover': {
                opacity: 1,
              },
            }}
          >
            <Close />
          </IconButton>
        )}
      </Stack>
    </Box>
  )
}
